var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.167 3.75a.75.75 0 0 1 .75.75v1.667a2.25 2.25 0 0 0 2.25 2.25h5.856L9.97 6.363a.75.75 0 0 1 1.06-1.06l3.333 3.333.015.016a.7.7 0 0 1 .085.11q.024.038.043.08.012.023.023.046.054.13.055.279a.75.75 0 0 1-.186.49q-.011.013-.024.026l-.01.013-3.334 3.334a.75.75 0 0 1-1.06-1.06l2.051-2.053H6.167a3.75 3.75 0 0 1-3.75-3.75V4.5a.75.75 0 0 1 .75-.75"
  })));
};
export default Svg16;